// extracted by mini-css-extract-plugin
export default {"index":"fodder-need_index__x8WhR","body":"fodder-need_body__MBQ37","toolbar":"fodder-need_toolbar__GOMrD","left":"fodder-need_left__4fjDn"};